// extracted by mini-css-extract-plugin
module.exports = {"remindingButton":"styles_remindingButton__1akoh"};